/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const providerTypePayload = {
  providerIdType: [],
  providerDetails: [],
  contactDetails: [],
  existingContactDetails: [],
  contactDescription: [],
  providerList: [],
  providerTabData: {},
};

const reducer = (state = providerTypePayload, action) => {
  switch (action.type) {
    case actionTypes.SEARCH_PROVIDER_DETAILS: {
      return { ...state, providerList: action.providerList };
    }
    case actionTypes.GET_PROVIDERIDTYPE_DATA: {
      return { ...state, providerIdType: action.providerIdType };
    }
    case actionTypes.GET_PROVIDER_DETAILS: {
      return { ...state, providerDetails: action.providerDetails };
    }
    case actionTypes.GET_PROVIDER_DETAILS_DATA: {
      return { ...state, providerDetailsData: action.providerDetailsData };
    }
    case actionTypes.GET_CONTACT_DETAILS: {
      return { ...state, contactDetails: action.contactDetails };
    }
    case actionTypes.GET_CONTACT_DESCRIPTION_DETAILS: {
      return { ...state, contactDescription: action.contactDescription };
    }
    case actionTypes.GET_EXISTING_CONTACT_DETAILS: {
      return {
        ...state,
        existingContactDetails: action.existingContactDetails,
      };
    }
    case actionTypes.SEARCH_PROVIDER_REQUEST: {
      return { ...state, searchProviderRequest: action.payload };
    }
    case actionTypes.SET_PROVIDER_TAB_DATA: {
      return { ...state, providerTabData: action.payload };
    }
    default:
      return state;
  }
};

export default reducer;
